import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

export interface ProductsHeaderProps {
    url: string
    enableSearchBannerTemplating: boolean
    templating: {mainTemplate: string; fallbackTemplate: string}
}

const ProductsHeader = memo(({url, enableSearchBannerTemplating, templating}: ProductsHeaderProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)

    return (
        <Suspense>
            <ComponentName url={url} enableSearchBannerTemplating={enableSearchBannerTemplating} />
        </Suspense>
    )
})

ProductsHeader.displayName = "ProductsHeader"

export default connect(ProductsHeader)
